import { resolveEnableFlag } from '@/features/order/order-form/lib/enable-flag'
import type { OrderFormCollapsibleConfig } from '@/state/order'

/**
 * True when the entry-condition editor holds any usable trigger data. Mirrors
 * the structured-tree-first / legacy-flat-fallback shape the submit path reads.
 */
export function hasTriggerData(config: OrderFormCollapsibleConfig | null | undefined): boolean {
  if (!config) return false
  const isComposite = config.entryConditionLogic === 'all' || config.entryConditionLogic === 'any'
  return Boolean(
    config.entryConditionTreeJson ||
    (isComposite
      ? config.entryConditionGroupJson
      : config.entryConditionPrice ||
        config.entryConditionDelaySeconds ||
        config.entryConditionFireAtMs ||
        config.entryConditionActionTargetValue)
  )
}

/**
 * Whether the trigger should arm the order on submit.
 * - `'true'`  → on
 * - `'false'` → off (user explicitly disabled; inputs are kept but ignored)
 * - unset     → on when data is present. This preserves triggers saved before
 *   the enable flag existed and matches the auto-on-when-edited model: the first
 *   edit writes `'true'`, so the unset branch only ever covers legacy configs.
 */
export function isTriggerActive(config: OrderFormCollapsibleConfig | null | undefined): boolean {
  if (!config) return false
  return resolveEnableFlag(config.entryConditionEnabled, hasTriggerData(config))
}
